import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, useTheme, Typography } from "@mui/material";
import { tokens } from "../../theme";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faCheckCircle, faTimesCircle, faCheckDouble } from "@fortawesome/free-solid-svg-icons";

import CustomToolbar from "../admin-table/custom-toolbar";

import IconButton from '@mui/material/IconButton';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ProdsTable = ({ data , handleOpen, handleChangeOnTbale}) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const MySwal = withReactContent(Swal);

    const formatNumber = (data) => {
        if(!data){
            return '-'
        } 
        return data.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }
    const handlerEditTransaction = (data) => {
        const {id_produto} = data
        if(id_produto){
            handleChangeOnTbale(id_produto)
            handleOpen()
            console.log('data here: ', data)
        }
    }

    const formatDate = (date) => {
        if (!date) {
            return "-"
        }
        const newDate = date.split('-').reverse().join('/')
        return newDate
    }

    const columns = [
        // {
        //     field: "count",
        //     headerName: ".",
        //     flex: 0.2,
        //     renderHeader: params =>
        //         <Box
        //             sx={{
        //                 display: "flex",
        //                 justifyContent: "center",
        //                 alignItems: "center"
        //             }}
        //         >
        //             <ArrowDropDownIcon color="success" />
        //         </Box>
        // },
        // { field: "sellerId", headerName: "ID Vendedor", flex: 1 },
        {
            field: "purchase_date",
            headerName: "Data Compra",
            flex: 1,
            renderCell: params =>
                <Typography color={colors.greenAccent[400]}>
                    {formatDate(params.row.purchase_date)}
                </Typography>
        },
        {
            field: "id_produto",
            headerName: "Produto",
            flex: 0.9,
            renderCell: params =>
                <Typography
                >
                    {params.row.id_produto}
                </Typography>
        },
        {
            field: "color__color",
            headerName: "Tipo",
            headerAlign: "left",
            align: "left",
            flex: 0.5
        },
        {
            field: "supplier__name",
            headerName: "Fornecedor",
            flex: 1,
            cellClassName: "name-column--cell"
        },
        {
            field: "id_supplier",
            headerName: "ID Fornecedor",
            flex: 0.9,
            renderCell: params =>
                <Typography
                >
                    {params.row.id_supplier}
                </Typography>
        },
        {
            field: "model",
            headerName: "Model",
            flex: 0.9,
            renderCell: params =>
                <Typography
                >
                    {params.row.model}
                </Typography>
        },

        { field: "initial_inventory", headerName: "Quantidade Comprada", flex: 1.5 },
        { field: "quantity_available", headerName: "Quantidade Disponível", flex: 1.5 },
        {
            field: "cost_price", headerName: "Preço Custo", flex: 1.5, renderCell: params =>
                <Typography
                >
                    {formatNumber(params.row.cost_price)}
                </Typography>
        },
        {
            field: "charged_price", headerName: "Preço Venda", flex: 1.5, renderCell: params =>
                <Typography
                >
                    {formatNumber(params.row.charged_price)}
                </Typography>
        },
        {
            field: "action",
            headerName: ".",
            flex: 0.4,
            renderCell: params =>
                <IconButton aria-label="deactivate" onClick={() =>
                    handlerEditTransaction(params.row)
                }
                    sx={{ cursor: "pointer" }}
                >
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        color={colors.yellow[600]}
                        size="sm"

                    />
                </IconButton>
        },
    ];

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "600px",
                height: "100%",
                margin: "10px",
                marginTop: '0px',
                padding: "40px",
                paddingTop: '0px',
                whiteSpace: "nowrap",
            }}
        >
            {/* <Typography variant="h3" color={colors.blueAccent[400]} fontWeight={"bold"}>
                Operações
            </Typography> */}
            <Box
                m="10px 0 0 0"
                height="95%"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none"
                    },
                    "& .MuiDataGrid-cell": {
                        // borderBottom: "none"
                    },
                    "& .name-column--cell": {
                        color: colors.pink[100]
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none"
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400]
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800]
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`
                    },
                    "& .pix": {
                        color: `${colors.blueAccent[300]} !important`
                    },
                    "& .credito": {
                        color: `${colors.greenAccent[400]} !important`
                    },
                    zIndex: '1200'
                }}
            >
                <DataGrid
                    rows={data}
                    columns={columns}
                    components={{ Toolbar: CustomToolbar }}
                    componentsProps={{ toolbar: { title: 'Vendas' } }}
                />
            </Box>
        </Box>
    );
}

export default ProdsTable;